"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _excluded = ["color", "size"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Wifi = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  var {
    color,
    size
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: size,
    height: size,
    fill: color
  }, rest), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("style", null, ".a{fill:none;}.b{fill:#4a4a4a;}")), /*#__PURE__*/_react.default.createElement("defs", null), /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(780 -468)"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    className: "a",
    width: "16",
    height: "16",
    transform: "translate(-780 468)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "b",
    d: "M1,0A1,1,0,1,1,0,1,1,1,0,0,1,1,0Z",
    transform: "translate(-773 479.5)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "b",
    d: "M-773.2,481.351l.033.032a.483.483,0,0,0,.656.017,5.965,5.965,0,0,1,3.843-1.4,5.964,5.964,0,0,1,3.837,1.4.483.483,0,0,0,.656-.018l.032-.032a.481.481,0,0,0-.036-.709A6.961,6.961,0,0,0-768.67,479a6.96,6.96,0,0,0-4.495,1.643A.481.481,0,0,0-773.2,481.351Z",
    transform: "translate(-3.33 -5.5)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "b",
    d: "M-768.932,486.486l.034.034a.473.473,0,0,0,.612.048,2.974,2.974,0,0,1,1.75-.568,2.975,2.975,0,0,1,1.745.565.473.473,0,0,0,.611-.049l.034-.034a.477.477,0,0,0-.05-.721,3.967,3.967,0,0,0-2.34-.761,3.969,3.969,0,0,0-2.346.766A.477.477,0,0,0-768.932,486.486Z",
    transform: "translate(-5.463 -8.5)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: "b",
    d: "M-764.151,476.237a.5.5,0,0,0-.013-.72A9.953,9.953,0,0,0-770.785,473a9.954,9.954,0,0,0-6.624,2.52.5.5,0,0,0-.015.717h0a.505.505,0,0,0,.7.016A8.95,8.95,0,0,1-770.785,474a8.953,8.953,0,0,1,5.94,2.25.505.505,0,0,0,.694-.013Z",
    transform: "translate(-1.215 -2.5)"
  })));
});
Wifi.propTypes = {
  color: _propTypes.default.string,
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  onClick: _propTypes.default.func
};
Wifi.defaultProps = {
  color: 'currentColor',
  size: '1em',
  onClick: () => {}
};
var _default = Wifi;
exports.default = _default;